module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "notifications"
    }
  }, [_c('h2', [_vm._v("Notifications")]), _vm._v(" "), (_vm.notificationsFetchingStatus !== 'fetched') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.notificationsFetchingStatus === 'fetched') ? [_vm._l((_vm.notifications), function(notification) {
    return (_vm.notifications.length > 0 && notification.text && notification.link) ? _c('router-link', {
      class: {
        new: notification.hasBeenRead === 0
      },
      attrs: {
        "to": notification.link
      }
    }, [_c('span', {
      staticClass: "text"
    }, [(!notification.hasBeenRead) ? _c('i', {
      staticClass: "fas fa-bell"
    }) : _vm._e(), _vm._v(" " + _vm._s(notification.text))]), _vm._v(" "), _c('span', {
      staticClass: "time-stamp"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(notification.created)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.notifications.length === 0) ? _c('span', {
    staticClass: "no-notifications-message"
  }, [_vm._v("You don't have any notifications")]) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a923364!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Notifications/Notifications.vue
// module id = 842
// module chunks = 2